import React from 'react'
import { Tag } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { getChipInfo } from '../helpers/helpers'

type ScoreTagProps = {
  score?: number
  isVerbose?: boolean
}

export default function ScoreTag({ score, isVerbose }: ScoreTagProps): JSX.Element {
  const { textKey, color } = getChipInfo(score, isVerbose ? 'verbose' : undefined)
  const [t] = useTranslation()

  return <Tag text={t(textKey)} color={color} />
}
